<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option v-for="item in records" :key="item.id" :title="item.name" :value="item.id">{{
      item.name
    }}</a-select-option>
  </a-select>
</template>

<script lang="ts">
import { LicenseListService } from "@/views/license-manage/license-list/license-list.service";
import { defineComponent, onMounted } from "vue";

/**
 * 证书
 *
 * 使用方式:
 * <license-select v-model:value="formRef.id"></license-select>
 */
export default defineComponent({
  isGlobal: false,
  props: {
    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    api: {
      type: String,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = LicenseListService.usePageApi();
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };
    onMounted(async () => {
      const req = {
        current: 1,
        size: 1000,
      };
      await run(req);
    });

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
